module.exports = __webpack_public_path__ + "static/media/Image-7.fe2e3de9.jpg";